<template>
  <div>
    <!-- <v-snackbar v-model="showSnackBar" color="#68D389" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #ffffff">
            {{ msg }}
          </span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #ffffff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar> -->

    <!-- <v-layout wrap justify-start>
      <v-flex xs12>
        <v-layout
          wrap
          justify-center
          align-center
          v-for="entry in holymass"
          :key="entry._id"
        >
          <v-flex xs12 sm2 md3 lg2 pr-1>
           
            <v-text-field
            class="text-field"
            placeholder="Select Date"
            outlined
            dense
            
            :value="formatDate(entry.OccasionDate)"
            @click="dialogdate = true"
            readonly
          ></v-text-field>


            <v-dialog v-model="dialogdate" max-width="290">
              
              <v-date-picker
                v-model="entry.OccasionDate"
                @input="updateDate(entry, entry.OccasionDate)"
              ></v-date-picker>

            </v-dialog>
          </v-flex>

          <v-flex xs12 sm2 md3 lg2 pr-1>
            <v-menu
              v-model="entry.menu"
              :close-on-content-click="false"
              :nudge-bottom="40"
              transition="slide-y-reverse-transition"
              width="200"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="entry.formattedTime"
                  
                  outlined
                  dense
                  class="text-field"
                  placeholder="Select Time"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-card class="time-picker-card" width="auto">
                <v-card-text class="time-picker-card-text">
                  <v-layout row wrap>
                    <v-flex xs4>
                      <v-select
                        v-model="entry.selectedHour"
                        :items="hours"
                        label="Hour"
                        
                        solo
                        dense
                        class="time-picker-select"
                        @change="updateFormattedTime(entry)"
                      ></v-select>
                    </v-flex>
                    <v-flex xs4>
                      <v-select
                        v-model="entry.selectedMinute"
                        :items="minutes"
                        label="Minute"
                        solo
                        dense
                        
                        class="time-picker-select"
                        @change="updateFormattedTime(entry)"
                      ></v-select>
                    </v-flex>
                    <v-flex xs4>
                      <v-select
                        v-model="entry.selectedPeriod"
                        :items="periods"
                        label="AM/PM"
                        solo
                        dense
                        
                        class="time-picker-select"
                        @change="updateFormattedTime(entry)"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-menu>
          </v-flex>

          <v-flex xs12 sm2 md3 lg3 pr-1>
            <v-text-field
              class="text-field"
              placeholder="Holy Mass name"
              outlined
              dense
              
              v-model="entry.massName"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm2 md3 lg2 pr-1>
            <v-select
              outlined
              dense
              
              :items="riteArray"
              v-model="entry.rite"
              placeholder="Select Rite"
              class="text-field"
              item-text="name"
              item-value="_id"
            ></v-select>
          </v-flex>

          <v-flex xs12 sm2 md3 lg3 pr-0>
            <v-select
              outlined
              dense
              
              :items="languageArray"
              item-text="languageName"
              item-value="_id"
              v-model="entry.language"
              placeholder="Select Language"
              class="text-field"
            ></v-select>
          </v-flex>

          <v-flex>
     
            <v-btn
              icon
            
              @click="removeEntry(index)"
              color="red"
              small
              v-if="holymass.length > 1"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout> -->
    <v-snackbar v-model="showSnackBar" color="primary" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #ffffff">
            {{ msg }}
          </span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #ffffff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <v-form v-model="formValid" ref="holyMassForm">
      <v-layout wrap justify-center>
        <v-flex xs12 sm12 pl-lg-10 pl-md-10 pl-sm-10>
          <v-layout
            class="pb-2"
            wrap v-for="(entry, index) in holymass"
            :key="entry._id"
          >
            <v-flex xs11 sm4 md6 lg4 pr-2>
              <v-text-field
                class="text-field"
                placeholder="Select Date"
                outlined
                dense
                :value="formatDate(entry.OccasionDate)"
                @click="dialogdate = true"
                :rules="[rules.required]"
              ></v-text-field>

              <v-dialog v-model="dialogdate" max-width="290">
                <v-date-picker
                  v-model="entry.OccasionDate"
                  :min="nowDate"
                  @input="updateDate(entry, entry.OccasionDate)"
                ></v-date-picker>
              </v-dialog>
            </v-flex>

            <v-flex xs11 sm3 md6 lg4 pr-lg-2 pr-md-2 pr-sm-2 pr-2>
              <v-menu
                v-model="entry.menu"
                :close-on-content-click="false"
                :nudge-bottom="40"
                transition="slide-y-reverse-transition"
                width="200"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="entry.formattedTime"
                    outlined
                    dense
                    class="text-field pt-sm-0 pt-lg-0 pt-md-0 pt-2"
                    placeholder="Select Time"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :rules="[rules.required]"
                  ></v-text-field>
                </template>
                <v-card class="time-picker-card" width="auto">
                  <v-card-text class="time-picker-card-text">
                    <v-layout row wrap>
                      <v-flex xs4>
                        <v-select
                          v-model="entry.selectedHour"
                          :items="hours"
                          label="Hour"
                          solo
                          dense
                          hide-details
                          class="time-picker-select"
                          :rules="[rules.required]"
                          @change="updateFormattedTime(entry)"
                        ></v-select>
                      </v-flex>
                      <v-flex xs4>
                        <v-select
                          v-model="entry.selectedMinute"
                          :items="minutes"
                          label="Minute"
                          solo
                          dense
                          hide-details
                          class="time-picker-select"
                          :rules="[rules.required]"
                          @change="updateFormattedTime(entry)"
                        ></v-select>
                      </v-flex>
                      <v-flex xs4>
                        <v-select
                          v-model="entry.selectedPeriod"
                          :items="periods"
                          label="AM/PM"
                          solo
                          dense
                          hide-details
                          class="time-picker-select"
                          :rules="[rules.required]"
                          @change="updateFormattedTime(entry)"
                        ></v-select>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-menu>
            </v-flex>

            <v-flex xs11 sm4 md4 lg4 pr-2 pt-2 pt-lg-0 pt-sm-0 pt-md-0>
              <v-text-field
                class="text-field"
                placeholder="Holy Mass name"
                outlined
                dense
                v-model="entry.massName"
                :rules="[rules.required]"
              ></v-text-field>
            </v-flex>

            <v-flex xs11 sm6 md3 lg4 pr-2 pt-sm-2 pt-lg-0 pt-md-0 pt-2>
              <v-select
                outlined
                dense
                :items="riteArray"
                v-model="entry.rite"
                placeholder="Select Rite"
                class="text-field"
                item-text="name"
                item-value="_id"
                :rules="[rules.required]"
              ></v-select>
            </v-flex>

            <v-flex xs11 sm5 md4 lg4 pr-2 pt-sm-2 pt-lg-0 pt-md-0 pt-2>
              <v-select
                outlined
                dense
                :items="languageArray"
                item-text="languageName"
                item-value="_id"
                v-model="entry.language"
                placeholder="Select Language"
                class="text-field"
                :rules="[rules.required]"
              ></v-select>
            </v-flex>
            <v-flex xs11 sm12 md4 lg4 pr-lg-2 pr-md-2 pr-sm-1 pt-2 pt-lg-0 pt-sm-2 pt-md-0>
              <v-text-field v-model="entry.location" outlined dense
              class="text-field pt-sm-2 pt-lg-0 pt-md-0 pt-2" placeholder="Enter Location" 
             ></v-text-field>
            </v-flex>

            <v-flex xs10 pl-3 pb-2>
              <v-layout row align-center>
                <span class="live-des mr-2">
                  Is a special event held after Holy Mass?
                </span>
                <v-checkbox
                  v-model="entry.isSpecialEventAfterMass"
                  color="primary"
                  hide-details
                  class="mt-0"
                ></v-checkbox>
              </v-layout>
            </v-flex>
            
            <!-- Conditional v-select -->
            <v-flex
              v-if="entry.isSpecialEventAfterMass" 
              xs10
              sm11
              md11
              lg11
              pr-lg-2
              pr-md-2
              pr-sm-1
              pt-2
              pt-lg-2
              pt-sm-2
              pt-md-2
            >
            <v-select
            class="pt-2 text-des"
            style="font-size: 14px"
           
            outlined
            dense
            :items="eventArray"
            v-model="entry.holymassEvent"
            item-text="name"
            item-value="name"
            placeholder="Select Events"
            multiple
          ></v-select>
            </v-flex>
            

            <v-flex xs1 sm1 md1 lg1 align-self-center d-flex justify-center align-center>
              <v-btn 
                class="ml-0"
                icon
                @click="removeEntry(index)"
                color="red"
                small
                v-if="holymass.length > 1"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-flex>
            
          </v-layout>
        </v-flex>
      </v-layout>

      <v-flex pl-lg-10 pl-sm-0 pl-md-10 pl-0 pt-0>
        <v-btn outlined color="blue darken-5" @click="addEntry" small
          ><v-icon> mdi-plus </v-icon>More</v-btn
        >
      </v-flex>

      <v-flex xs12 text-end pb-3>
        <v-btn
          class="ml-16"
          color="blue darken-1"
          @click="submitForm"
          style="font-family: interregular; font-size: 15px; color: white"
          >Add Holy Mass</v-btn
        >
      </v-flex>
    </v-form>
  </div>
</template>




<script>
import axios from "axios";
//import AddSpecialMass from './addSpecialMass.vue';
export default {
  // components:{
  //   AddSpecialMass
  // },
  data() {
    return {
      isSpecialEventAfterMass: false,
      formValid: false,
      rules: {
        required: (value) => !!value || "This field is required",
      },
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      deletedialog: false,
      dialogdate: false,
      OccasionDate: "",
      massName: "",
      hours: Array.from({ length: 12 }, (_, i) =>
        (i + 1).toString().padStart(2, "0")
      ),
      minutes: Array.from({ length: 60 }, (_, i) =>
        i.toString().padStart(2, "0")
      ),
      periods: ["AM", "PM"],
      // edit

      // selectedDay: null,
      holyMassEntries: [],

      // menu2: false,
      isAdding: false,
      expanded: true,
      currentAddType: null,

      // hoursArray: Array.from({ length: 12 }, (_, i) => String(i + 1)), // ['1', '2', ..., '12']
      // minutesArray: Array.from({ length: 60 }, (_, i) =>
      //   String(i).padStart(2, "0")
      // ),
      // periodArray: ["AM", "PM"],

      riteArray: [],
      languageArray: [],
      holymassEvent: [],
      eventArray: [], 
      holymass: [
        {
          rite: "",
          language: "",
          location:"",
          selectedHour: "",
          selectedMinute: "",
          selectedPeriod: "",
          OccasionDate: "",
          massName: "",
          OccasionType: "Special",
          menu: false,
          holymassEvent:[]
        },
      ],
    };
  },

  computed: {
    formattedTime() {
      return `${this.selectedHour}:${this.selectedMinute} ${this.selectedPeriod}`;
    },
    // formattedTime() {
    //   return this.selectedHour && this.selectedMinute && this.selectedPeriod
    //     ? `${this.selectedHour}:${this.selectedMinute} ${this.selectedPeriod}`
    //     : ""; // Placeholder text
    // },
    formattedDate() {
      // Only format and return the date if one is selected
      return this.OccasionDate
        ? new Date(this.OccasionDate).toLocaleDateString()
        : "";
    },
    nowDate() {
      const now = new Date();
      return now.toISOString().substr(0, 10);
    },
  },
  mounted() {
    this.getLanguage();
    this.getRite();
    this.getEvent();
    //this.getData();
    // this.setDefaultDay();
  },
  methods: {
    // date
    updateDate(entry, date) {
      entry.OccasionDate = date;
      this.dialogdate = false; // Close the dialog after selecting the date
    },
    formatDate(date) {
      return date ? new Date(date).toLocaleDateString() : "";
    },

    addEntry() {
      this.holymass.push({
        rite: "",
        language: "",
        location:"",
        selectedHour: "",
        selectedMinute: "",
        selectedPeriod: "",
        menu: false,
        OccasionDate: "",
        formattedTime: "",
        formattedDate: "",
        massName: "",
        OccasionType: "Special",
        holymassEvent:[]
      });
    },

    removeEntry(index) {
      this.holymass.splice(index, 1);
    },

    convertTo24HourFormat(hour, minute, period) {
      let convertedHour = parseInt(hour, 10);

      // Convert 12 AM to 00 (midnight) in 24-hour format
      if (period === "AM" && convertedHour === 12) {
        convertedHour = 0;
      }
      // Convert 12-hour PM time to 24-hour format (except 12 PM)
      else if (period === "PM" && convertedHour !== 12) {
        convertedHour += 12; // Convert to 24-hour format for PM times
      }

      return `${convertedHour.toString().padStart(2, "0")}:${minute
        .toString()
        .padStart(2, "0")}`;
    },

    updateFormattedTime(entry) {
      // This sets the formatted time to display in 12-hour format with AM/PM
      entry.formattedTime = `${entry.selectedHour}:${entry.selectedMinute} ${entry.selectedPeriod}`;
      console.log(entry.formattedTime);
    },

    getEvent() {
      this.appLoading = true;
      axios({
        url: "/get/holymass/events",
        method: "GET",

        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.eventArray = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    getRite() {
      this.appLoading = true;
      axios({
        url: "/get/rite/list",
        method: "GET",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.riteArray = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    getLanguage() {
      this.appLoading = true;
      axios({
        url: "/get/language/list",
        method: "GET",

        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.languageArray = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    submitForm() {
      if (this.$refs.holyMassForm.validate()) {
        this.itemadd(); // Your existing method for adding Holy Mass
      } else {
        this.msg = "Please fill out all required fields";
        this.showSnackBar = true;
      }
    },

    itemadd() {
      const data = {
        parish: this.$route.query.id,
        holymass: this.holymass.map((entry) => ({
          rite: entry.rite,
          language: entry.language,
          location:entry.location,
          massName: entry.massName,
          OccasionDate: entry.OccasionDate,
          OccasionType: entry.OccasionType,
          startTime: this.convertTo24HourFormat(
            entry.selectedHour,
            entry.selectedMinute,
            entry.selectedPeriod
          ),
          holymassEvent: entry.holymassEvent
        })),
      };

      axios({
        url: "/add/multiple/holymasses",
        method: "POST",
        data: data,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.dialog = false;

            // Emit an event to notify parent component
            console.log("Emitting dataAdded event");
            this.$emit("dataAdded", {
              ref: "addSpecial",
              getSpecialData: true,
            });
            this.expanded = true;
            //window.location.reload();

            // Reset the form fields
            this.OccasionDate = null;
            this.holymass = [
              {
                rite: "",
                language: "",
                location:"",
                selectedHour: "12",
                selectedMinute: "00",
                selectedPeriod: "AM",
                OccasionDate: "",
                massName: "",
                menu: false,
                OccasionType: "Special",
                holymassEvent: []  
              },
            ];
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    // itemadd() {
    //   const data = {
    //     // if(this.holyrite || this.ghh){
    //     //   dayOfWeek:this.holyrite
    //     // }
    //     // assuming you have parishId defined in your data
    //     parish: this.$route.query.id,
    //     //dayOfWeek: this.selectedDay,
    //     holymass: this.holymass.map((entry) => ({
    //       rite: entry.rite,
    //       language: entry.language,
    //       massName: entry.massName,
    //       OccasionDate: entry.OccasionDate,
    //       OccasionType: entry.OccasionType,
    //       // startTime: entry.formattedTime, // Combine time
    //       startTime: this.convertTo24HourFormat(
    //         entry.selectedHour,
    //         entry.selectedMinute,
    //         entry.selectedPeriod
    //       ),
    //       // Include occasionType if applicable
    //     })),
    //   };

    //   axios({
    //     url: "/add/multiple/holymasses",
    //     method: "POST",
    //     data: data,
    //     headers: {
    //       token: localStorage.getItem("token"),
    //     },
    //   })
    //     .then((response) => {
    //       this.appLoading = false;
    //       if (response.data.status) {
    //         this.msg = "Added Successfully";
    //         this.showsnackbar = true;
    //         this.dialog = false;
    //         this.$emit("stepper", {
    //           ref: "addSpecial",
    //           getSpecialData: true,
    //         });
    //         // Clear form fields or reset state
    //         this.OccasionDate = null;
    //         this.holymass = [
    //           {
    //             rite: "",
    //             language: "",
    //             selectedHour: "12",
    //             selectedMinute: "00",
    //             selectedPeriod: "AM",
    //             OccasionDate: "",
    //             massName: "",
    //             menu: false,
    //             OccasionType: "Special",
    //           },
    //         ];

    //       } else {
    //         this.msg = response.data.msg;
    //         this.showsnackbar = true;
    //       }
    //     })
    //     .catch((err) => {
    //       this.appLoading = false;
    //       this.ServerError = true;
    //       console.log(err);
    //     });
    // },

    // formatTimes(startTime) {
    //     return `${this.convertUTCToLocal(startTime)} `;
    //   },
    formatTime(dateTime) {
      // Extract the time part from the string
      const timePart = dateTime.split("T")[1].split("Z")[0];

      // Split time into hours and minutes
      let [hours, minutes] = timePart.split(":");

      // Convert hours to a number
      hours = parseInt(hours);

      // Determine AM/PM
      const ampm = hours >= 12 ? "PM" : "AM";

      // Convert 24-hour time to 12-hour time
      hours = hours % 12;
      hours = hours ? hours : 12; // Adjust 0 to 12

      // Combine hours, minutes, and AM/PM
      const formattedTime = `${hours}:${minutes} ${ampm}`;

      return formattedTime;
    },
  },
};
</script>

<style scoped>
.time-picker-card {
  max-width: 280px;
  /* Adjust card width */
}

.time-picker-card-text {
  padding: 8px;
  /* Adjust padding inside the card */
}

.time-picker-select {
  width: 100%;
  /* Ensure dropdowns fill column width */
}

.time-picker-card-actions {
  padding: 8px;
  /* Adjust padding in the actions area */
}

.v-menu__content {
  z-index: 1000;
  /* Ensure the menu appears on top */
}

.v-card {
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.text-field {
  font-family: interregular;
  font-size: 14px;
  color: black;
}
</style>